<template>
  <div class="nihao">
    <div style=" font-size: 15px; text-align:center;font-weight: bold;padding: 12px;border-bottom: 1px solid #e6e6e6;">
          聊天内容
        </div>
        <div class="category">
          <el-tabs v-model="msgSort" type="card" stretch>
            <el-tab-pane label="全部" name="all"></el-tab-pane>
            <el-tab-pane label="文件" name="file"></el-tab-pane>
            <el-tab-pane label="图片" name="image"></el-tab-pane>
            <el-tab-pane label="通话" name="call"></el-tab-pane>
          </el-tabs>
        </div>
    <div class="chat-test" style="height: 86%; width: 100%;">
      <normal-log
      v-show="msgSort=='all'"
      :data="recordContent"
      :loading="loading"
      :total="total"
      :size="size"
      :showMore="showMore"
      @loadMore="loadMore" />

      <file-log
      v-show="msgSort=='file'"
      :data="recordContent"
      :loading="loading"
      :total="total"
      :size="size"
      :showMore="showMore"
      @loadMore="loadMore" />

      <image-log
      v-show="msgSort=='image'"
      :data="recordContent"
      :loading="loading"
      :total="total"
      :size="size"
      :showMore="showMore"
      @loadMore="loadMore" />
      
      <audio-log
      v-show="msgSort=='call'"
      :data="recordContent"
      :loading="loading"
      :total="total"
      :size="size"
      :showMore="showMore"
      @loadMore="loadMore" />
    </div>
  </div>
</template>
<script>
import { getDialogInfo } from "../../../api/customer/customer.js";
import normalLog from "../../../components/chatLog/normal.vue";
import FileLog from "../../../components/chatLog/fileLog.vue";
import ImageLog from "../../../components/chatLog/imageLog.vue";
import AudioLog from "../../../components/chatLog/audioLog.vue";
export default {
  props: ["idData"],
  components: { normalLog, FileLog, ImageLog, AudioLog },
  data() {
    return {
      recordContent: [],
      showMore: false,
      total: 0,
      current: 1,
      size: 10,
      sendFrom: "",
      sendTo: "",
      msgSort: "all",
      loading: false,
      showMorePosition: 0,
    };
  },
  provide() {
    return{
      showMorePosition: () => this.showMorePosition,
      setPosition: this.setPosition
    }
  },
  created() {},
  methods: {
    getDialog(sendFrom, sendTo, current, size, msgSort) {
      let msgType = null
      if(msgSort=='file' || msgSort=='image') {
        msgType = msgSort
      }else if(msgSort=='call') {
        this.recordContent = []
        return
      }
      this.loading = true;
      getDialogInfo(
        sendFrom,
        sendTo,
        current,
        size,
        localStorage.getItem("Authorization"),
        true,
        msgType
      ).then((dialog) => {
        this.recordContent = dialog.data;
        this.total = dialog.data.length;
        if (this.total === size) {
          this.showMore = true;
        } else {
          this.showMore = false;
        }
        this.loading = false;
      });
    },
    clickMore() {
      this.size = this.size + 10;
      this.getDialog(this.sendFrom, this.sendTo, this.current, this.size,this.msgSort);
    },
    setPosition(value) {
      this.showMorePosition = value
    },
    resetParams() {
      this.recordContent = [];
      this.showMore = false;
      this.total = 0;
      this.current = 1;
      this.size = 10;
      this.showMorePosition = 0;
    },
    loadMore() {
      this.size = this.size + 10;
      this.getDialog(
        this.sendFrom,
        this.sendTo,
        this.current,
        this.size,
        this.msgSort
      );
    },
    
  },
  watch: {
    idData: {
      handler(newVal, oldVal) {
        this.recordContent = [];
        this.showMore = false;
        this.total = 0;
        this.current = 1;
        this.size = 10;
        this.showMorePosition = 0;
        (this.sendFrom = newVal[0]),
          (this.sendTo = newVal[1]),
          console.log(newVal);
        if (newVal.length > 0) {
          if (newVal[1] != "") {
            this.getDialog(newVal[0], newVal[1], this.current, this.size,this.msgSort);
          }
        }
      },
    },
    msgSort: {
      handler(newVal, oldVal) {
        if(!this.idData || !this.idData.length) return
        this.resetParams()
        this.getDialog(
          this.sendFrom,
          this.sendTo,
          this.current,
          this.size,
          this.msgSort
        );
      },
    },
  },

};
</script>
<style lang="scss">
.category {
  width: 100%;
  .el-tabs__header {
    margin: 0 !important;
    .el-tabs__item.is-active {
      border-bottom: none !important; 
    }
    .el-tabs__nav {
      border: none !important;
    }
    .el-tabs__item {
      border-left: none;
      border-right: 1px solid #E4E7ED;
    }
  }
}
.nihao {
  width: 100%;
  height: 100%;
  .chat-test {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: #f0f0f5;
   
  }
}
</style>